export default "__VITE_ASSET__ebc26fde__"